/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CiselnikHodnotaVO } from '../model';
// @ts-ignore
import { ShapefileMetadataVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ShpImportControllerApi - axios parameter creator
 * @export
 */
export const ShpImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Metoda pro import vrstvy z SHP souborů
         * @param {ShapefileMetadataVO} [shapefileMetadataVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importLayer: async (shapefileMetadataVO?: ShapefileMetadataVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/import-layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shapefileMetadataVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro upload CSV souboru s hodnotami číselníkového atributu
         * @param {File} [file] CSV soubor obsahující hodnoty číselníku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCsv: async (file?: File, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/upload-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro upload ZIP balíčku s SHP soubory
         * @param {File} [file] ZIP soubor obsahující SHP soubory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadShp: async (file?: File, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/upload-shp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShpImportControllerApi - functional programming interface
 * @export
 */
export const ShpImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShpImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Metoda pro import vrstvy z SHP souborů
         * @param {ShapefileMetadataVO} [shapefileMetadataVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importLayer(shapefileMetadataVO?: ShapefileMetadataVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.importLayer(shapefileMetadataVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro upload CSV souboru s hodnotami číselníkového atributu
         * @param {File} [file] CSV soubor obsahující hodnoty číselníku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCsv(file?: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CiselnikHodnotaVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCsv(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro upload ZIP balíčku s SHP soubory
         * @param {File} [file] ZIP soubor obsahující SHP soubory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadShp(file?: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShapefileMetadataVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadShp(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShpImportControllerApi - factory interface
 * @export
 */
export const ShpImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShpImportControllerApiFp(configuration)
    return {
        /**
         * Metoda pro import vrstvy z SHP souborů
         * @param {ShapefileMetadataVO} [shapefileMetadataVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importLayer(shapefileMetadataVO?: ShapefileMetadataVO, options?: any): AxiosPromise<void> {
            return localVarFp.importLayer(shapefileMetadataVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro upload CSV souboru s hodnotami číselníkového atributu
         * @param {File} [file] CSV soubor obsahující hodnoty číselníku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCsv(file?: File, options?: any): AxiosPromise<Array<CiselnikHodnotaVO>> {
            return localVarFp.uploadCsv(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro upload ZIP balíčku s SHP soubory
         * @param {File} [file] ZIP soubor obsahující SHP soubory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadShp(file?: File, options?: any): AxiosPromise<ShapefileMetadataVO> {
            return localVarFp.uploadShp(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShpImportControllerApi - interface
 * @export
 * @interface ShpImportControllerApi
 */
export interface ShpImportControllerApiInterface {
    /**
     * Metoda pro import vrstvy z SHP souborů
     * @param {ShapefileMetadataVO} [shapefileMetadataVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApiInterface
     */
    importLayer(shapefileMetadataVO?: ShapefileMetadataVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro upload CSV souboru s hodnotami číselníkového atributu
     * @param {File} [file] CSV soubor obsahující hodnoty číselníku
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApiInterface
     */
    uploadCsv(file?: File, options?: any): AxiosPromise<Array<CiselnikHodnotaVO>>;

    /**
     * Metoda pro upload ZIP balíčku s SHP soubory
     * @param {File} [file] ZIP soubor obsahující SHP soubory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApiInterface
     */
    uploadShp(file?: File, options?: any): AxiosPromise<ShapefileMetadataVO>;

}

/**
 * ShpImportControllerApi - object-oriented interface
 * @export
 * @class ShpImportControllerApi
 * @extends {BaseAPI}
 */
export class ShpImportControllerApi extends BaseAPI implements ShpImportControllerApiInterface {
    /**
     * Metoda pro import vrstvy z SHP souborů
     * @param {ShapefileMetadataVO} [shapefileMetadataVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApi
     */
    public importLayer(shapefileMetadataVO?: ShapefileMetadataVO, options?: any) {
        return ShpImportControllerApiFp(this.configuration).importLayer(shapefileMetadataVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro upload CSV souboru s hodnotami číselníkového atributu
     * @param {File} [file] CSV soubor obsahující hodnoty číselníku
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApi
     */
    public uploadCsv(file?: File, options?: any) {
        return ShpImportControllerApiFp(this.configuration).uploadCsv(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro upload ZIP balíčku s SHP soubory
     * @param {File} [file] ZIP soubor obsahující SHP soubory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShpImportControllerApi
     */
    public uploadShp(file?: File, options?: any) {
        return ShpImportControllerApiFp(this.configuration).uploadShp(file, options).then((request) => request(this.axios, this.basePath));
    }
}
